import lscache from "lscache";

/** Shared with KM so a user who dismissed the hint on either site never sees it twice. */
const GALLERY_SWIPE_ONBOARDING_SEEN_STORAGE_KEY = "kmGallerySwipeOnboardingSeen";

type Listener = () => void;

export interface IGallerySwipeOnboardingSnapshot {
    hostId: string | null;
    seen: boolean;
}

const createInitialSnapshot = (): IGallerySwipeOnboardingSnapshot => ({
    hostId: null,
    seen: Boolean(lscache.get(GALLERY_SWIPE_ONBOARDING_SEEN_STORAGE_KEY))
});

const createGallerySwipeOnboardingStore = () => {
    let snapshot = createInitialSnapshot();
    const listeners = new Set<Listener>();

    const emit = () => {
        listeners.forEach((listener) => listener());
    };

    const setSnapshot = (next: IGallerySwipeOnboardingSnapshot) => {
        snapshot = next;
        emit();
    };

    return {
        subscribe: (listener: Listener) => {
            listeners.add(listener);

            return () => {
                listeners.delete(listener);
            };
        },
        getSnapshot: () => snapshot,
        getServerSnapshot: (): IGallerySwipeOnboardingSnapshot => ({hostId: null, seen: true}),
        claimHost: (galleryId: string) => {
            if (snapshot.seen || snapshot.hostId !== null) return;

            setSnapshot({...snapshot, hostId: galleryId});
        },
        releaseHost: (galleryId: string) => {
            if (snapshot.hostId !== galleryId) return;

            setSnapshot({...snapshot, hostId: null});
        },
        markSeen: () => {
            if (snapshot.seen) return;

            lscache.set(GALLERY_SWIPE_ONBOARDING_SEEN_STORAGE_KEY, true);
            setSnapshot({hostId: null, seen: true});
        },
        /** @internal tests only */
        resetForTests: () => {
            setSnapshot(createInitialSnapshot());
        }
    };
};

export const gallerySwipeOnboardingStore = createGallerySwipeOnboardingStore();
import lscache from "lscache";

/** Shared with KM so a user who dismissed the hint on either site never sees it twice. */
const GALLERY_SWIPE_ONBOARDING_SEEN_STORAGE_KEY = "kmGallerySwipeOnboardingSeen";

type Listener = () => void;

export interface IGallerySwipeOnboardingSnapshot {
    hostId: string | null;
    seen: boolean;
}

const createInitialSnapshot = (): IGallerySwipeOnboardingSnapshot => ({
    hostId: null,
    seen: Boolean(lscache.get(GALLERY_SWIPE_ONBOARDING_SEEN_STORAGE_KEY))
});

const createGallerySwipeOnboardingStore = () => {
    let snapshot = createInitialSnapshot();
    const listeners = new Set<Listener>();

    const emit = () => {
        listeners.forEach((listener) => listener());
    };

    const setSnapshot = (next: IGallerySwipeOnboardingSnapshot) => {
        snapshot = next;
        emit();
    };

    return {
        subscribe: (listener: Listener) => {
            listeners.add(listener);

            return () => {
                listeners.delete(listener);
            };
        },
        getSnapshot: () => snapshot,
        getServerSnapshot: (): IGallerySwipeOnboardingSnapshot => ({hostId: null, seen: true}),
        claimHost: (galleryId: string) => {
            if (snapshot.seen || snapshot.hostId !== null) return;

            setSnapshot({...snapshot, hostId: galleryId});
        },
        releaseHost: (galleryId: string) => {
            if (snapshot.hostId !== galleryId) return;

            setSnapshot({...snapshot, hostId: null});
        },
        markSeen: () => {
            if (snapshot.seen) return;

            lscache.set(GALLERY_SWIPE_ONBOARDING_SEEN_STORAGE_KEY, true);
            setSnapshot({hostId: null, seen: true});
        },
        /** @internal tests only */
        resetForTests: () => {
            setSnapshot(createInitialSnapshot());
        }
    };
};

export const gallerySwipeOnboardingStore = createGallerySwipeOnboardingStore();
